import { render, staticRenderFns } from "./TransferSubscription.vue?vue&type=template&id=062bb4f6"
import script from "./TransferSubscription.vue?vue&type=script&lang=js"
export * from "./TransferSubscription.vue?vue&type=script&lang=js"
import style0 from "./TransferSubscription.vue?vue&type=style&index=0&id=062bb4f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports